import * as React from 'react';
import { ProductInterface } from '../../Model/Product';
import { Trans } from '../Trans';

interface ResultDescriptionProps {
    filteredProducts: ProductInterface[]
    allProducts: ProductInterface[]
}

export class ResultDescription extends React.Component<ResultDescriptionProps, {}> {
    public render() {
        const props = this.props;
        const filteredProducts = props.filteredProducts;
        const allProducts = props.allProducts;

        return <div className="pf-results">
            <strong>
                <Trans arguments={[filteredProducts.length, allProducts.length]}
                       id="matches_d_of_d_products">Matches: {filteredProducts.length} of {allProducts.length} products</Trans>
            </strong>
        </div>;
    }
}
